// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Second register page form wrapper - 2 column layout */
.register-user-info-form_wrapper__ZS3rl {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  gap: clamp(30px, 4vw, 60px);
  width: 90vw;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 0;
  padding: 0 20px;
}

.register-user-info-form_leftColumn__m0WIv {
  display: flex;
  flex-direction: column;
  place-items: center;
  gap: clamp(15px, 2.5vh, 25px);
  flex: 1 1;
  min-width: 0;
}

.register-user-info-form_rightColumn__dD4ES {
  display: flex;
  flex-direction: column;
  place-items: center;
  flex: 1 1;
  min-width: 0;
}

.register-user-info-form_textBoxWrapper__T3yJ1 {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}


.register-user-info-form_calendarContainer__ZHJNc {
  /* position: absolute;
  top: 100%;
  left: 0; */
  width: 20vw;
  z-index: 10;
  background-color: #1a1a1a;
  /* Match your gaming theme (black background) */
  border: 1px solid #444;
  border-radius: 5px;
  padding: 10px;
}

@media (max-width: 768px) {

  /* Adjust breakpoint as needed */
  .register-user-info-form_calendarContainer__ZHJNc {
    width: 60vw;
  }
}

/* .custom-calendar {
  color: #FFE5B0;
  background-color: #1a1a1a; 
  border: none;
  border-radius: 5px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
} */

/* .custom-calendar {
  background-color: #121212;
  border: 1px solid #61dafb;
  border-radius: 8px;
  color: #ffffff;
}

/* register-user-info-form.module.css */
.react-calendar__tile {
  background: transparent;
  color: #ffffff;
  border-radius: 5px;
  font-size: 1rem;
  transition: background 0.3s ease;
}

.react-calendar__tile:hover {
  background: #dfdfdf96;
}

.react-calendar__tile--active {
  background: #CFE5FF;
  color: #000000;
}

.react-calendar__navigation button {
  color: #FFE5B0;
  background: transparent;
  border: none;
  font-size: 1rem;
}

.react-calendar__navigation button:disabled {
  color: #555;
}

.react-calendar__month-view__weekdays {
  background: #1a1a1a;
  color: #FFE5B0;
  font-weight: bold;
}

/* :global(.react-calendar__month-view__days__day--weekend) {
  color: #ff5722;
} */

/* Tablet adjustments - stack columns */
@media (max-width: 1024px) {
  .register-user-info-form_wrapper__ZS3rl {
    flex-direction: column;
    align-items: center;
    gap: clamp(20px, 3vh, 30px);
    width: 80vw;
  }

  .register-user-info-form_leftColumn__m0WIv,
  .register-user-info-form_rightColumn__dD4ES {
    width: 100%;
    max-width: 500px;
  }
}

/* Mobile adjustments */
@media (max-width: 768px) {
  .register-user-info-form_wrapper__ZS3rl {
    flex-direction: column;
    align-items: center;
    gap: 20px;
    width: 95vw;
    padding: 0 10px;
  }

  .register-user-info-form_leftColumn__m0WIv,
  .register-user-info-form_rightColumn__dD4ES {
    width: 100%;
    max-width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/features/profile/components/register-user-info-form.module.css"],"names":[],"mappings":"AAAA,wDAAwD;AACxD;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,2BAA2B;EAC3B,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,6BAA6B;EAC7B,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAO;EACP,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;;AAGA;EACE;;YAEU;EACV,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,+CAA+C;EAC/C,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;AACf;;AAEA;;EAEE,gCAAgC;EAChC;IACE,WAAW;EACb;AACF;;AAEA;;;;;;GAMG;;AAEH;;;;;;;uCAOuC;AACvC;EACE,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;;GAEG;;AAEH,uCAAuC;AACvC;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,2BAA2B;IAC3B,WAAW;EACb;;EAEA;;IAEE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA,uBAAuB;AACvB;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,eAAe;EACjB;;EAEA;;IAEE,WAAW;IACX,eAAe;EACjB;AACF","sourcesContent":["/* Second register page form wrapper - 2 column layout */\n.wrapper {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: flex-start;\n  gap: clamp(30px, 4vw, 60px);\n  width: 90vw;\n  max-width: 1200px;\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: 0;\n  padding: 0 20px;\n}\n\n.leftColumn {\n  display: flex;\n  flex-direction: column;\n  place-items: center;\n  gap: clamp(15px, 2.5vh, 25px);\n  flex: 1;\n  min-width: 0;\n}\n\n.rightColumn {\n  display: flex;\n  flex-direction: column;\n  place-items: center;\n  flex: 1;\n  min-width: 0;\n}\n\n.textBoxWrapper {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n\n.calendarContainer {\n  /* position: absolute;\n  top: 100%;\n  left: 0; */\n  width: 20vw;\n  z-index: 10;\n  background-color: #1a1a1a;\n  /* Match your gaming theme (black background) */\n  border: 1px solid #444;\n  border-radius: 5px;\n  padding: 10px;\n}\n\n@media (max-width: 768px) {\n\n  /* Adjust breakpoint as needed */\n  .calendarContainer {\n    width: 60vw;\n  }\n}\n\n/* .custom-calendar {\n  color: #FFE5B0;\n  background-color: #1a1a1a; \n  border: none;\n  border-radius: 5px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);\n} */\n\n/* .custom-calendar {\n  background-color: #121212;\n  border: 1px solid #61dafb;\n  border-radius: 8px;\n  color: #ffffff;\n}\n\n/* register-user-info-form.module.css */\n:global(.react-calendar__tile) {\n  background: transparent;\n  color: #ffffff;\n  border-radius: 5px;\n  font-size: 1rem;\n  transition: background 0.3s ease;\n}\n\n:global(.react-calendar__tile:hover) {\n  background: #dfdfdf96;\n}\n\n:global(.react-calendar__tile--active) {\n  background: #CFE5FF;\n  color: #000000;\n}\n\n:global(.react-calendar__navigation button) {\n  color: #FFE5B0;\n  background: transparent;\n  border: none;\n  font-size: 1rem;\n}\n\n:global(.react-calendar__navigation button:disabled) {\n  color: #555;\n}\n\n:global(.react-calendar__month-view__weekdays) {\n  background: #1a1a1a;\n  color: #FFE5B0;\n  font-weight: bold;\n}\n\n/* :global(.react-calendar__month-view__days__day--weekend) {\n  color: #ff5722;\n} */\n\n/* Tablet adjustments - stack columns */\n@media (max-width: 1024px) {\n  .wrapper {\n    flex-direction: column;\n    align-items: center;\n    gap: clamp(20px, 3vh, 30px);\n    width: 80vw;\n  }\n\n  .leftColumn,\n  .rightColumn {\n    width: 100%;\n    max-width: 500px;\n  }\n}\n\n/* Mobile adjustments */\n@media (max-width: 768px) {\n  .wrapper {\n    flex-direction: column;\n    align-items: center;\n    gap: 20px;\n    width: 95vw;\n    padding: 0 10px;\n  }\n\n  .leftColumn,\n  .rightColumn {\n    width: 100%;\n    max-width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `register-user-info-form_wrapper__ZS3rl`,
	"leftColumn": `register-user-info-form_leftColumn__m0WIv`,
	"rightColumn": `register-user-info-form_rightColumn__dD4ES`,
	"textBoxWrapper": `register-user-info-form_textBoxWrapper__T3yJ1`,
	"calendarContainer": `register-user-info-form_calendarContainer__ZHJNc`
};
export default ___CSS_LOADER_EXPORT___;
